import React from 'react'

import usePosts from "../hooks/use-posts"
import useCategories from "../hooks/use-categories"
import useMediaTypes from "../hooks/use-media-types"

import ArticleCard from './cards/article'
import PostsFilter from './posts-filter'
import { Filter, CloseFilter } from './icons'

const PostsArchive = ({ title = 'Recent posts' }) => {
  // Data
  const posts = usePosts()
  const categories = useCategories()
  const mediaTypes = useMediaTypes()
  // State
  const [list, setList] = React.useState(posts)
  const [limit, setLimit] = React.useState(14)
  const [active, setActive] = React.useState(false)

  // Ref
  const load = React.createRef()

  // Events
  let timeout = null
  const onScroll = () => {
    let position = load?.current?.getBoundingClientRect()
    if (!position) return
    if (position.top >= 0 && position.bottom <= window.innerHeight) {
      if (!timeout) {
        //if (!this.timeout && this.state.length < this.state.list) {
        timeout = setTimeout(() => {
          setLimit(limit + 6)
          timeout = null
        }, 10)
      }
    } else {
      clearTimeout(timeout)
    }
  }

  // Update
  React.useEffect(() => {
    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  })

  return (
    <>
      <section className='posts-archive'>
        <div className='posts-archive__inner'>
          <div className='posts-archive__header'>
            {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
            <button onClick={() => setActive(!active)}>{active ? <CloseFilter /> : <Filter />}</button>
            <div className={`posts-archive__filter ${active ? 'active' : ''}`}>
              <PostsFilter
                list={posts || []}
                set={setList}
                mediaTypes={mediaTypes}
                categories={categories}
              />
            </div>
          </div>
          <div className='posts-archive__list'>
            {list?.slice(0, limit).map((el) => (<ArticleCard key={el.id} {...el} />))}
            {list?.length === 0 && <p className='posts-archive__no-results'>No posts match your search. Please try again.</p>}
          </div>
        </div>
      </section>
      <div ref={load} />
    </>
  )
}

export default PostsArchive 